import { useState } from "react";
import { Facebook, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";

const XIcon = () => <span className="text-[11px] font-black">X</span>;

export const ShareButtons = ({ item, dark = false }) => {
  const [busy, setBusy] = useState(false);
  const url = `${window.location.origin}/work/${item.id}`;
  const text = `${item.title || "Our work"} — Firm Foundations Construction`;
  const cls = `grid h-8 w-8 place-items-center rounded-full transition-colors ${dark ? "bg-white/15 text-white hover:bg-[#F2B91C] hover:text-[#0E1F3F]" : "bg-white/90 text-[#0E1F3F] hover:bg-[#F2B91C]"}`;
  const open = (href) => window.open(href, "_blank", "noopener,width=640,height=520");
  const native = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (navigator.share) await navigator.share({ title: text, url });
      else {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied");
      }
    } catch {}
    setBusy(false);
  };
  return (
    <div className="flex gap-1.5" data-testid={`share-${item.id}`}>
      <button className={cls} aria-label="Share on Facebook" data-testid={`share-facebook-${item.id}`} onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)}><Facebook size={14} /></button>
      <button className={cls} aria-label="Share on X" data-testid={`share-x-${item.id}`} onClick={() => open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`)}><XIcon /></button>
      <button className={cls} aria-label="Copy link" data-testid={`share-copy-${item.id}`} onClick={async () => { await navigator.clipboard.writeText(url); toast.success("Link copied"); }}><Link2 size={14} /></button>
      {navigator.share && <button className={cls} aria-label="More" data-testid={`share-more-${item.id}`} onClick={native}><Share2 size={14} /></button>}
    </div>
  );
};
